import React, { useState } from 'react';
import { SortOrder } from 'antd/es/table/interface';
import { Button, Tooltip } from 'antd';
import cx from 'classnames';

import { SortingDirectionEnum } from 'enums';

import styles from './BaseSortButton.module.less';

type Props = {
  isActive: boolean;
  className?: string;
  sortHidden?: boolean;
  label: string | React.ReactNode;
  sortType: SortOrder | undefined;
};

const getTootltipTitle = (isActive: boolean, sortType?: SortOrder) => {
  if (!isActive) return 'Ascending/Descending';

  return sortType === SortingDirectionEnum.Ascend ? 'Ascending' : 'Descending';
};

const BaseSortButton = React.memo((props: Props) => {
  const {
    sortType,
    className = '',
    isActive,
    label,
    sortHidden = false,
  } = props;
  const tooltipTitle = getTootltipTitle(isActive, sortType);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const handleMouseEnter = () => {
    if (sortHidden) return;

    setIsTooltipVisible(true);
  };

  const handleMouseLeave = () => {
    // Fix quick hovering all sort buttons
    setTimeout(() => setIsTooltipVisible(false), 0);
  };

  return (
    <Button
      type="link"
      className={cx(styles.root, className, {
        [styles.inactive]: !isActive,
        [styles.sortHidden]: sortHidden,
      })}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span>{label}</span>

      {!sortHidden && (
        <span className={styles.tooltipContainer}>
          <Tooltip
            placement="top"
            title={tooltipTitle}
            open={isTooltipVisible}
            overlayClassName="light-tooltip"
          >
            <>
              {/* Display arrow down only for descend order and active status */}
              {isActive && sortType === SortingDirectionEnum.Descend ? (
                <i className={cx('icon icon-arrow-down', styles.sortIcon)}></i>
              ) : (
                // Otherwise display arrow up in order to have hover effect
                <i
                  className={cx('icon icon-arrow-up', styles.sortIcon, {
                    [styles.hiddenButton]: !isActive,
                  })}
                ></i>
              )}
            </>
          </Tooltip>
        </span>
      )}
    </Button>
  );
});

export default BaseSortButton;
